module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp23_5010.93725900.png";